import { NgIfContext } from '@angular/common';
import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { AppConstants } from '../app.constants';
import { AuthorizationByStatusModel } from '../models/authorization-model';

@Directive({
  selector: '[removeIfUnauthorizedIR]'
})
export class RemoveIfUnauthorizedIRDirective {
  private hasView: boolean = false;

  constructor(private container: ViewContainerRef,
    private template: TemplateRef<any>,
    private authService: AuthService) { }

  @Input() set removeIfUnauthorizedIRElse(elseTemplateRef: TemplateRef<NgIfContext> | null) {
    if (!this.hasView && elseTemplateRef) {
      this.container.createEmbeddedView(elseTemplateRef);
    }
  }

  @Input() set removeIfUnauthorizedIR(authModel: AuthorizationByStatusModel) {
    if (authModel == null || !authModel.role.length || !authModel.roleUserType.length) {
      this.hasView = false;
      this.container.clear();
      return;
    }

    let hasRole = !!authModel.role.length && this.authService.hasRole(authModel.role);
    let hasUserTypeRole = this.authService.hasUserTypeRole(authModel.roleUserType);
    let isCreator = this.authService.isCreator(authModel.creatorId);
    let isAssignee = authModel.assigneeIds?.map(x => x.toLowerCase()).includes(this.authService.currentUserId.toLowerCase())
    let hasAuthOrgCode = this.authService.hasOrgCode(authModel.authOrgCode);
    let isStateLocalLE = this.authService.hasUserType(['StateLocalLE']);

    if (authModel.entityState == AppConstants.IR_FormMode_Add && authModel.canCreate) {
      if ((hasRole || hasUserTypeRole) && this.hasView) {
        this.hasView = true;
      } else if ((hasRole || hasUserTypeRole) && !this.hasView) {
        this.container.createEmbeddedView(this.template);
        this.hasView = true;
      } else if (!(hasRole || hasUserTypeRole) && this.hasView) {
        this.container.clear();
        this.hasView = false;
      } else if (!(hasRole || hasUserTypeRole) && !this.hasView) {
        this.hasView = false;
      } else {
        this.container.clear();
        this.hasView = false;
      }
    } else if (authModel.entityState == AppConstants.IR_FormMode_Edit) {
      if (isStateLocalLE) {
        if ((hasRole || (isAssignee && hasUserTypeRole)) && this.hasView) {
          this.hasView = true;
        } else if ((hasRole || (isAssignee && hasUserTypeRole)) && !this.hasView) {
          this.container.createEmbeddedView(this.template);
          this.hasView = true;
        } else if (!(hasRole || (isAssignee && hasUserTypeRole)) && this.hasView) {
          this.container.clear();
          this.hasView = false;
        } else if (!(hasRole || (isAssignee && hasUserTypeRole)) && !this.hasView) {
          this.hasView = false;
        } else {
          this.container.clear();
          this.hasView = false;
        }
      } else if (hasRole || (hasUserTypeRole && hasAuthOrgCode)) {
        if ((hasRole || this.authService.hasRole(['Application Administrator']) || isCreator || isAssignee) && this.hasView) {
          this.hasView = true;
        } else if ((hasRole || this.authService.hasRole(['Application Administrator']) || isCreator || isAssignee) && !this.hasView) {
          this.container.createEmbeddedView(this.template);
          this.hasView = true;
        } else if (!(hasRole || this.authService.hasRole(['Application Administrator']) || isCreator || isAssignee) && this.hasView) {
          this.container.clear();
          this.hasView = false;
        } else if (!(hasRole || this.authService.hasRole(['Application Administrator']) || isCreator || isAssignee) && !this.hasView) {
          this.hasView = false;
        } else {
          this.container.clear();
          this.hasView = false;
        }
      } else {
        this.container.clear();
        this.hasView = false;
      }
    } else if (authModel.entityState == AppConstants.IR_FormMode_View) {
      if ((hasRole || (isStateLocalLE && isAssignee && hasUserTypeRole) || (!isStateLocalLE && hasUserTypeRole)) && this.hasView) {
        this.hasView = true;
      } else if ((hasRole || (isStateLocalLE && isAssignee && hasUserTypeRole) || (!isStateLocalLE && hasUserTypeRole)) && !this.hasView) {
        this.container.createEmbeddedView(this.template);
        this.hasView = true;
      } else if (!(hasRole || (isStateLocalLE && isAssignee && hasUserTypeRole) || (!isStateLocalLE && hasUserTypeRole)) && this.hasView) {
        this.container.clear();
        this.hasView = false;
      } else if (!(hasRole || (isStateLocalLE && isAssignee && hasUserTypeRole) || (!isStateLocalLE && hasUserTypeRole)) && !this.hasView) {
        this.hasView = false;
      } else {
        this.container.clear();
        this.hasView = false;
      }
    } else {
      this.container.clear();
      this.hasView = false;
    }
  }
}
